<template>
  <RouterLink
    :to="categoryLink"
    :class="[
      'bg-white rounded-md hover:opacity-80 flex flex-col delay-200 duration-500 transition border-surface-grey border',
      list ? 'md:flex-row' : '',
      inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4',
    ]"
  >
    <div
      ref="inviewRef"
      :id="`category-${category.id}`"
      :class="[
        'aspect-16/9 border-b border-surface-grey relative',
        list
          ? 'md:shrink-0 md:w-90 h-full md:aspect-auto md:rounded-l-md md:rounded-r-none md:border-b-0 md:border-r'
          : '',
      ]"
    >
      <img
        :src="photoToUrl(category.photo)"
        :alt="categoryName"
        :class="[
          'w-full h-full object-cover rounded-t-md aspect-16/9',
          list ? 'md:rounded-l-md md:rounded-t-none md:rounded-r-none' : '',
        ]"
      />
      <svg
        :class="[
          'absolute z-10 bottom-0 -right-[1px] translate-y-1/2 fill-surface-light stroke-surface-grey stroke-1',
          list
            ? 'md:rotate-90 md:translate-y-0 md:-translate-x-full md:-bottom-[1px] md:right-0 md:origin-bottom-right'
            : '',
        ]"
        xmlns="http://www.w3.org/2000/svg"
        width="7"
        height="16"
        viewBox="0 0 7 16"
      >
        <path
          d="M7.5 0.518555C3.59105 0.775917 0.5 4.02593 0.5 8C0.5 11.9741 3.59105 15.2241 7.5 15.4814V0.518555Z"
        />
      </svg>

      <svg
        :class="[
          'absolute bottom-0 -left-[1px] z-10 translate-y-1/2 fill-surface-light stroke-surface-grey stroke-1',
          list
            ? 'md:rotate-90 md:translate-x-full md:-top-[2px] md:left-auto md:bottom-auto md:-right-[1px] md:origin-top-right'
            : '',
        ]"
        xmlns="http://www.w3.org/2000/svg"
        width="7"
        height="16"
        viewBox="0 0 7 16"
        fill="none"
      >
        <path
          d="M-0.5 0.518555C3.40895 0.775917 6.5 4.02593 6.5 8C6.5 11.9741 3.40895 15.2241 -0.5 15.4814V0.518555Z"
        />
      </svg>
    </div>
    <div :class="['p-4 grow', list ? '' : '']">
      <div
        :class="[
          list
            ? 'md:flex md:justify-between md:border-b md:border-surface-grey md:mb-3'
            : '',
        ]"
      >
        <div :class="[list ? 'md:flex-1 ' : '']">
          <h2
            class="h4 mb-2 line-clamp-2"
            :class="list ? 'md:line-clamp-1' : ''"
          >
            {{ categoryName }}
          </h2>
        </div>
      </div>
      <!-- <div class="flex items-center text-sm text-headings"> // use as template if you want to add more content
        <span>{{ category.num_events }} {{ $t('event.events').toLowerCase() }}</span>
      </div> -->
    </div>
  </RouterLink>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';

  import type { Category } from '@/types';
  import { getLocalizedCategoryValue } from '@/utils/getCategoryLocalization';
  import { photoToUrl } from '@/utils/photoToUrl';
  import { useInView } from '@/utils/useInView';

  const { locale } = useI18n();

  const props = defineProps<{
    category: Category;
    list?: boolean;
  }>();

  const { inviewRef, inView } = useInView();

  const categoryName = computed(() =>
    getLocalizedCategoryValue(props.category, locale.value, 'name')
  );

  const categoryLink = computed(() => {
    if (props.category.extlink) {
      return props.category.extlink;
    }
    // if (props.category.short_url) { TODO short_url is currently not implemented for categories. I'm not sure if we should even use it here.
    //   return `/${props.category.short_url}`;
    // }
    return `/?category=${encodeURIComponent(props.category.name)}`;
  });
</script>
